module.exports = __webpack_public_path__ + "img/music_017.965db260.png";